import update from 'react-addons-update';
import { SAVE_LOOKUP_ITEMS } from '../actions/lookupitemsAction';

let initialState = { lookupitems: {} };

export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_LOOKUP_ITEMS:
      return saveLookupList(state, action);
    default:
      return { ...state };
  }
};

function saveLookupList(state, action) {
  const preFormatData = (action.payload || []).reduce((prev, item) => {
    if (!prev[item.LookupListID]) prev[item.LookupListID] = [item];
    else prev[item.LookupListID] = [...prev[item.LookupListID], item];
    return prev;
  }, {});

  return update(state, { lookupitems: { $set: preFormatData } });
}



// WEBPACK FOOTER //
// ./src/@redux/reducers/lookupitemsReducer.js